/**
 * Debounce function that delays invoking callback until after wait milliseconds
 *
 * @param {Function} callback - The function to debounce
 * @param {number} wait - The number of milliseconds to delay
 * @returns {Function} - The debounced function
 */
export default function(callback, wait = 200) {
  let timeoutId

  return function(...args) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => callback.apply(this, args), wait)
  }
}
